import React, { useContext } from "react";
import { GroupProvider } from "@dimensions/group/context/GroupContext";
import GroupRestrictions, { GroupRestrictionsProps } from "./GroupRestrictions";
import { ContextEDH } from "@context/ContextEDH";
import GroupRestrictionsSkeleton from "./GroupRestrictionsSkeleton";

const GroupsRestrictionsLayout = (props: GroupRestrictionsProps) => {
  const { state: baseState } = useContext(ContextEDH);
  const isSettingsLoaded = baseState?.base?.restrictionConfigurations?.loaded;

  if (!isSettingsLoaded) {
    return <GroupRestrictionsSkeleton />;
  }

  return (
    <GroupProvider>
      <GroupRestrictions {...props} />
    </GroupProvider>
  );
};

export default GroupsRestrictionsLayout;
